import axiosInstance from '../lib/api/axiosInstance';
import {
  AdblockFilters,
  AdblockDomainsResponse,
  AdblockMetricsResponse
} from '../types/adblock';

/**
 * Service pour les APIs Adblock
 */
export class AdblockService {
  
  /**
   * Récupère les domaines disponibles pour l'utilisateur connecté
   */
  static async getDomains(): Promise<string[]> {
    try {
      console.log('=== ADBLOCK SERVICE: getDomains ===');
      console.log('Making request to:', '/adblock/domains');
      console.log('Base URL:', axiosInstance.defaults.baseURL);
      console.log('Full URL:', axiosInstance.defaults.baseURL + '/adblock/domains');
      
      const response = await axiosInstance.get<AdblockDomainsResponse>('/adblock/domains');
      
      console.log('Response received:', response);
      console.log('Response status:', response.status);
      console.log('Response data:', response.data);
      console.log('Domains count:', response.data.domains?.length || 0);
      
      return response.data.domains;
    } catch (error: any) {
      console.error('Error fetching adblock domains:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response,
        request: error.request,
        config: error.config,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });
      throw error;
    }
  }

  /**
   * Récupère les métriques Adblock avec les filtres appliqués
   */
  static async getMetrics(filters: AdblockFilters): Promise<AdblockMetricsResponse> {
    try {
      console.log('=== ADBLOCK SERVICE: getMetrics ===');
      console.log('Filters:', filters);
      
      const params = new URLSearchParams();
      params.append('startDate', filters.startDate);
      params.append('endDate', filters.endDate);
      
      // Ajouter les domaines sélectionnés
      if (filters.domains && filters.domains.length > 0) {
        filters.domains.forEach(domain => {
          params.append('domains', domain);
        });
      }

      // Ajouter les devices sélectionnés (seulement si pas vide = filtre spécifique)
      if (filters.devices && filters.devices.length > 0) {
        filters.devices.forEach(device => {
          params.append('devices', device);
        });
      }

      const url = `/adblock/metrics?${params.toString()}`;
      console.log('Making request to:', url);
      console.log('Base URL:', axiosInstance.defaults.baseURL);
      console.log('Full URL:', axiosInstance.defaults.baseURL + url);

      const response = await axiosInstance.get<AdblockMetricsResponse>(url);
      
      console.log('Response received:', response);
      console.log('Response status:', response.status);
      console.log('Response data:', response.data);
      console.log('Summary:', response.data.summary);
      console.log('Daily metrics count:', response.data.dailyMetrics?.length || 0);
      console.log('Domain metrics count:', response.data.domainMetrics?.length || 0);
      console.log('Device metrics count:', response.data.deviceMetrics?.length || 0);
      
      return response.data;
    } catch (error: any) {
      console.error('Error fetching adblock metrics:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response,
        request: error.request,
        config: error.config,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      });
      throw error;
    }
  }

  /**
   * Récupère les métriques avec des dates par défaut (30 derniers jours)
   */
  static async getDefaultMetrics(): Promise<AdblockMetricsResponse> {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 7); // 7 jours au lieu de 30

    const filters: AdblockFilters = {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0],
      domains: [],
      devices: [] // Vide = tous les devices
    };

    return this.getMetrics(filters);
  }
}

export default AdblockService;